/* Quick size sheet.

   Replaces the per-card size chips, which were 22x23px, revealed only on hover
   (so unusable on touch, where they were hidden outright) and each carried its
   own ~700-character inline onclick with a fetch in it - 209 copies of the same
   handler on the homepage alone.

   IT DOES NOT ADD TO CART, DELIBERATELY. Name and number printing, patches and
   the player-version upgrade are the store's margin, and they only exist on the
   product page - so does the size guide, and wrong size is the main cause of a
   return. Adding straight from a card would skip all of it. Picking a size here
   navigates to the product page with that variant already selected, which keeps
   the speed of the shortcut without cutting the configuration step out.

   Here: one delegated listener, one lazily built dialog, and the per-card data
   read from a JSON script tag the card already renders.

   Follows the pdp-wizard.js pattern (lazy build, .open class, Escape/backdrop
   close) without importing it: that module is wired to PDP-specific markup. */
(function () {
  'use strict';
  if (window.QuickSizeSheet) return;

  var backdrop = null;
  var sheet = null;
  var lastTrigger = null;
  var current = null;

  var ICON_CLOSE =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

  function build() {
    backdrop = document.createElement('div');
    backdrop.id = 'qss-backdrop';

    sheet = document.createElement('div');
    sheet.id = 'qss';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'בחירת מידה');
    sheet.innerHTML =
      '<div class="qss__grip" aria-hidden="true"></div>' +
      '<div class="qss__head">' +
        '<img class="qss__thumb" alt="" width="56" height="56">' +
        '<div class="qss__titles"><p class="qss__title"></p><span class="qss__price"></span></div>' +
        '<button type="button" class="qss__close" aria-label="סגירה">' + ICON_CLOSE + '</button>' +
      '</div>' +
      '<div class="qss__body">' +
        '<div class="qss__labelrow">' +
          '<p class="qss__label">בחרו מידה</p>' +
          '<a class="qss__guide" href="/pages/size-guide">מדריך מידות</a>' +
        '</div>' +
        '<div class="qss__grid"></div>' +
        '<p class="qss__error" role="alert" hidden></p>' +
      '</div>' +
      '<div class="qss__foot"><a class="qss__pdp" href="#">בעמוד המוצר תוסיפו שם, מספר ופאצ\'ים</a></div>';

    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);

    backdrop.addEventListener('click', close);
    sheet.querySelector('.qss__close').addEventListener('click', close);
    sheet.addEventListener('keydown', trapTab);
  }

  function trapTab(e) {
    if (e.key !== 'Tab') return;
    var items = sheet.querySelectorAll('button:not([disabled]), a[href]');
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(data, trigger) {
    if (!sheet) build();
    current = data;
    lastTrigger = trigger || null;

    var thumb = sheet.querySelector('.qss__thumb');
    if (data.image) { thumb.src = data.image; thumb.hidden = false; }
    else { thumb.removeAttribute('src'); thumb.hidden = true; }
    sheet.querySelector('.qss__title').textContent = data.title || '';
    sheet.querySelector('.qss__price').textContent = data.price || '';
    sheet.querySelector('.qss__pdp').href = data.url || '#';
    sheet.setAttribute('aria-label', 'בחירת מידה - ' + (data.title || ''));
    setError('');

    var grid = sheet.querySelector('.qss__grid');
    grid.innerHTML = '';
    (data.sizes || []).forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'qss__size';
      b.textContent = s.label;
      b.dataset.variantId = s.id;
      if (s.available) {
        b.setAttribute('aria-label', 'מידה ' + s.full);
      } else {
        b.disabled = true;
        b.setAttribute('aria-label', 'מידה ' + s.full + ' - אזלה מהמלאי');
      }
      grid.appendChild(b);
    });

    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('qss-open');
    requestAnimationFrame(function () {
      backdrop.classList.add('open');
      sheet.classList.add('open');
      var firstFree = sheet.querySelector('.qss__size:not([disabled])') || sheet.querySelector('.qss__close');
      if (firstFree) firstFree.focus();
    });
  }

  function close() {
    if (!sheet) return;
    backdrop.classList.remove('open');
    sheet.classList.remove('open');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('qss-open');
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  }

  function setError(msg) {
    var el = sheet && sheet.querySelector('.qss__error');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function goToProduct(btn) {
    var id = btn.dataset.variantId;
    if (!id || !current || !current.url) return;
    btn.classList.add('is-busy');
    var sep = current.url.indexOf('?') > -1 ? '&' : '?';
    document.dispatchEvent(new CustomEvent('jrs:quicksize:select', {
      detail: { variantId: id, productId: current.productId }
    }));
    window.location = current.url + sep + 'variant=' + encodeURIComponent(id);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-qss-trigger]');
    if (trigger) {
      var card = trigger.closest('.product-card');
      var json = card && card.querySelector('[data-qss-data]');
      if (!json) return;
      var data;
      try { data = JSON.parse(json.textContent); }
      catch (err) { window.location = trigger.dataset.qssUrl || (card.querySelector('a[href]') || {}).href || '/'; return; }
      e.preventDefault();
      open(data, trigger);
      return;
    }
    var size = e.target.closest && e.target.closest('#qss .qss__size');
    if (size && !size.disabled) goToProduct(size);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet && sheet.classList.contains('open')) close();
  });

  window.QuickSizeSheet = { open: open, close: close };
})();
